export enum Role {
  NoovaAdmin = 'NoovaAdmin',
  Admin = 'Admin',
  SuperUser = 'SuperUser',
  User = 'User',
  Guest = 'Guest',
}
